// extracted by mini-css-extract-plugin
export default {"tabs":"CustomTabs_tabs__VeO+h","tab":"CustomTabs_tab__Ijv0Y"};